import styled from 'styled-components'

export const Header = styled.div`
  display: flex;
  justify-content: space-between;
  flex-direction: row;
  padding: 15px;
  background-image: linear-gradient(148deg, #3c3671 10%, #7e009b 100%) !important;
  border-radius: 10px 10px 0px 0px;
  color: #fff;
  font-style: italic;
  font-weight: 100;
  img {
    border: 2px solid #fff;
    border-radius: 70%;
    padding: 2px;
    width: 35px;
    height: 35px;
    object-fit: cover;
    margin-right: 5px;
  }
`

export const BoxClose = styled.div`
  cursor: pointer;
`
export const BoxTitle = styled.div``
